import { render, staticRenderFns } from "./examManage.vue?vue&type=template&id=4e6df3dc&scoped=true&"
import script from "./examManage.vue?vue&type=script&lang=js&"
export * from "./examManage.vue?vue&type=script&lang=js&"
import style0 from "./examManage.vue?vue&type=style&index=0&id=4e6df3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6df3dc",
  null
  
)

export default component.exports